import { DialogProps, Dialog as MuiDialog } from "@mui/material";

type Props = DialogProps;

export const Dialog = ({ children, ...props }: Props) => {
  return <MuiDialog {...props}>{children}</MuiDialog>;
};
